/**
 * Parses a given date string and converts it to a JS UTC Date object.
 *
 * @param dateStr - The date string to be parsed and formatted.
 * @returns The parsed UTC Date object.
 */
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';

dayjs.extend(utc);

export function parseLocalDate(dateStr: string) {
  const a = dayjs.utc();
  const dayJsLocalDate = a.local().format(dateStr);
  return dayjs(dayJsLocalDate).toDate();
}
